import Random from '@/utilities/helper/Random'

export default {
  setFeedback: (state, payload) => {
    // avoid displaying the same message
    if (state.feedbacks.some(({ message }) => message === payload.message)) {
      return
    }

    state.feedbacks = [
      ...state.feedbacks.splice(-1 * (state.countMessages - 1)),
      {
        ...payload,
        uid: new Random().uid(),
      },
    ]
  },

  removeFeedback(state, id) {
    state.feedbacks = state.feedbacks.filter(({ uid }) => uid !== id)
  },
}
